<template>
    <div class="search-box">
        <svg width="20px" height="20px">
            <circle cx="7" cy="7" r="6" fill="transparent"/>
            <line x1="18" x2="12" y1="18" y2="12"/>
        </svg>
        <input type="search" :placeholder="placeholder" v-on:input="queryVenues" v-model="value">
    </div>
</template>

<script>
  import FuzzySearch from 'fuzzysearch'

  export default {
    name: 'searchVenues',
    props: [
      'placeholder',
      'venues'
    ],
    data () {
      return {
        value: '',
        results: [],
        showResults: false,
        searchByName: true,
        searchByAddress: true,
        searchByPostcode: true
      }
    },
    methods: {
      queryVenues () {
        const input = this.value.toLowerCase()

        if (input === '') {
          return this.hideResults()
        }

        this.emptyResults()

        let venueName
        let venueAddress
        let venuePostcode
        let venue

        for (let i = 0; i < this.venues.length; i++) {
          venue = this.venues[i]

          if (this.searchByName) {
            venueName = venue.name.toLowerCase()
            if (this.fuzzy(input, venueName)) {
              this.addToResults(venue)
              continue
            }
          }

          if (this.searchByAddress) {
            venueAddress = venue.address.toLowerCase()
            if (this.fuzzy(input, venueAddress)) {
              this.addToResults(venue)
              continue
            }
          }

          if (this.searchByPostcode) {
            venuePostcode = venue.postcode.replace(' ', '').toLowerCase()
            if (this.fuzzy(input, venuePostcode)) {
              this.addToResults(venue)
              continue
            }
          }
        }

        this.$emit('search', true)
        this.$emit('results', this.getResults())
      },

      emptyResults () {
        this.results = []
        return this
      },

      addToResults (venue) {
        this.results.push(venue)
        return this
      },

      getResults () {
        return this.results
      },

      hideResults () {
        this.$emit('search', false)
        this.showResults = false

        return this
      }

    },
    mounted () {
      this.fuzzy = FuzzySearch
    }
  }
</script>



// WEBPACK FOOTER //
// searchVenues.vue?0cedb9cc